var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.banners.length > 0)?_c('VueSlickCarousel',_vm._b({directives:[{name:"chakra",rawName:"v-chakra",value:({
      '.slick-prev': {
        width: '40px',
        height: '40px',
        left: '50px',
        backgroundImage: 'url(/images/chevron-left.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        zIndex: '1',
        '::before': {
          display: 'none',
        },
        ':focus': {
          backgroundImage: 'url(/images/chevron-left.png)',
        },
        ':hover': {
          backgroundImage: 'url(/images/chevron-left.png)',
        },
        '@media(max-width: 767px)': {
          display: 'none !important',
        },
      },
      '.slick-next': {
        right: '50px',
        width: '40px',
        height: '40px',
        backgroundImage: 'url(/images/chevron-right.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        zIndex: '1',
        '::before': {
          display: 'none',
        },
        ':focus': {
          backgroundImage: 'url(/images/chevron-right.png)',
        },
        ':hover': {
          backgroundImage: 'url(/images/chevron-right.png)',
        },
        '@media(max-width: 767px)': {
          display: 'none !important',
        },
      },
      '.slick-dots': {
        li: {
          button: {
            '::before': {
              fontSize: '12px',
            },
          },
          '&.slick-active': {
            button: {
              '::before': {
                color: 'brand.900',
              },
            },
          },
        },
      },
      '.slick-slide': {
        px: '30px',
        '@media(max-width: 767px)': {
          px: '0',
        },
      },
    }),expression:"{\n      '.slick-prev': {\n        width: '40px',\n        height: '40px',\n        left: '50px',\n        backgroundImage: 'url(/images/chevron-left.png)',\n        backgroundRepeat: 'no-repeat',\n        backgroundSize: '100%',\n        zIndex: '1',\n        '::before': {\n          display: 'none',\n        },\n        ':focus': {\n          backgroundImage: 'url(/images/chevron-left.png)',\n        },\n        ':hover': {\n          backgroundImage: 'url(/images/chevron-left.png)',\n        },\n        '@media(max-width: 767px)': {\n          display: 'none !important',\n        },\n      },\n      '.slick-next': {\n        right: '50px',\n        width: '40px',\n        height: '40px',\n        backgroundImage: 'url(/images/chevron-right.png)',\n        backgroundRepeat: 'no-repeat',\n        backgroundSize: '100%',\n        zIndex: '1',\n        '::before': {\n          display: 'none',\n        },\n        ':focus': {\n          backgroundImage: 'url(/images/chevron-right.png)',\n        },\n        ':hover': {\n          backgroundImage: 'url(/images/chevron-right.png)',\n        },\n        '@media(max-width: 767px)': {\n          display: 'none !important',\n        },\n      },\n      '.slick-dots': {\n        li: {\n          button: {\n            '::before': {\n              fontSize: '12px',\n            },\n          },\n          '&.slick-active': {\n            button: {\n              '::before': {\n                color: 'brand.900',\n              },\n            },\n          },\n        },\n      },\n      '.slick-slide': {\n        px: '30px',\n        '@media(max-width: 767px)': {\n          px: '0',\n        },\n      },\n    }"}]},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.banners),function(item,index){return _c('c-box',{key:index,staticClass:"item",attrs:{"pos":"relative","border-radius":"6px"}},[_c('c-box',{attrs:{"w":"100%","maxWidth":"578px","pos":"absolute","left":"50%","bottom":['40px', '80px'],"transform":"translateX(-50%)","textAlign":['left', 'center'],"zIndex":"1"}},[_c('c-heading',{attrs:{"w":"100%","px":['20px', ''],"as":"h1","color":"white","fontSize":"18px","fontWeight":"bold","lineHeight":"27px","marginBottom":"20px"}},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('c-text',{attrs:{"display":['none', 'inline-block'],"color":"white","fontSize":"14px","lineHeight":"21px","marginBottom":"33px","fontFamily":"Roboto"},domProps:{"innerHTML":_vm._s(item.content)}}),(item.url)?_c('c-button',{directives:[{name:"chakra",rawName:"v-chakra",value:({
            ':hover': {
              backgroundColor: 'white',
              color: 'brand.900',
              borderWidth: '1px',
              boderStyle: 'solid',
              borderColor: 'brand.900',
            },
          }),expression:"{\n            ':hover': {\n              backgroundColor: 'white',\n              color: 'brand.900',\n              borderWidth: '1px',\n              boderStyle: 'solid',\n              borderColor: 'brand.900',\n            },\n          }"}],attrs:{"as":"a","right-icon":"arrow-forward","backgroundColor":"secondary.900","color":"#927102","borderRadius":"100px","fontSize":"16px","borderWidth":"1px","boderStyle":"solid","borderColor":"transparent","py":"13px","px":"28px","h":"auto","lineHeight":"24px","fontFamily":"Roboto","display":['none', 'inline-block'],"href":item.url,"target":"_blank"}},[_vm._v(" Coba Sekarang ")]):_vm._e()],1),_c('c-box',{attrs:{"content":"","width":"100%","height":"100%","background":"linear-gradient(180deg, rgba(0, 0, 0, 0) -18.82%, rgba(0, 0, 0, 0.6) 68.95%)","position":"absolute","border-radius":"6px","top":"0","left":"0"}}),_c('c-image',{attrs:{"src":item.picture.url,"alt":"dietela","w":"100%","minHeight":"380px"}})],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }